import { useState, useContext, useEffect } from "react";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { useParams } from "react-router-dom";
import "../components/button.css";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import DataBowCalendar from "./DataBowCalendar";
import DataBowCalendarUsage from "./DataBowCalendarUsage";
import Reminder from "./Reminder";
import MyDays from "./MyDays";
import CycleReminder from "./CycleReminder";
import AddUserWeight from "./AddUserWeight";
import { Row } from "react-bootstrap";
import { marginBottom } from "../App";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function EditUserTabs({ user }) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    const savedTab = localStorage.getItem("selectedTab");
    if (savedTab) {
      setValue(parseInt(savedTab, 10));
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem("selectedTab", newValue);
  };

  const { id } = useParams();
  const { userData } = useContext(UserDataContext);

  return (
    <div>
      <VN userData={userData} />
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="underMenu"
            variant="scrollable"
            textColor="secondary"
            indicatorColor="secondary"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="Pamiętaj!" />
            <Tab label="Kalendarz leków" />
            <Tab label="Przypomnienia cykliczne" />
            <Tab label="Opisz dzień" />
            <Tab label="Waga" />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <Reminder />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Row style={{ marginBottom }}>
            <DataBowCalendar />
          </Row>
          {userData && userData.userId > 0 && (
            <DataBowCalendarUsage idVal={userData.userId} />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          {userData && <CycleReminder user={userData.userId} />}
        </CustomTabPanel>
        <CustomTabPanel value={value} index={3}>
          <MyDays />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={4}>
          <AddUserWeight />
        </CustomTabPanel>
      </Box>
    </div>
  );
}
